module.exports = __webpack_public_path__ + "static/media/webhook1.f80425b2.png";